import StantSortableListsComponent from "../../utils/sortable-list/stant-sortable-lists-component.coffee"
import * as I18n from "../../services/i18n"
import translations from "../../translations"

$(document).on "turbolinks:load", ->
  return unless $('#js_sortable_list').length

  # O sortableLists já é inicializado globalmente pelo StantSortableListsComponent
  # Vamos usar a mesma abordagem das outras páginas
  sortable_list = new StantSortableListsComponent()
  sortable_list.add_listeners()
  
  # Listener manual adicional para garantir que o botão apareça
  $('#js_sortable_list').on 'mousedown', '.dd-handle', ->
    $('.js_save_order').removeClass('hide')
    
  # Mostrar botão de salvar temporariamente para teste
  $('.js_save_order').removeClass('hide')

  # Salvar ordenação
  $(document).on 'click', '#js_save_strategic_status_order', ->
    button = $(this)
    originalText = button.text()
    url = button.data('action')
    
    # Preparar dados da ordenação usando sortableListsToArray
    serializedData = $('#js_sortable_list').sortableListsToArray()
    orderedData = buildOrderedDataFromSortable(serializedData)
    
    # Tentar diferentes formatos
    # Formato 1: Object simples
    simpleFormat = {
      strategic_status: {
        new_orders: orderedData
      }
    }
    
    # Formato 2: Rails format manual
    railsData = {}
    for item, index in orderedData
      railsData["strategic_status[new_orders][#{index}][id]"] = item.id
      railsData["strategic_status[new_orders][#{index}][order]"] = item.order
      if item.parentId?
        railsData["strategic_status[new_orders][#{index}][parentId]"] = item.parentId
    
    # Desabilitar botão
    button.prop('disabled', true).text('...')
    
    # Enviar dados
    $.ajax
      url: url
      type: 'PATCH'
      dataType: 'json'
      contentType: 'application/json'
      headers:
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      data: JSON.stringify(simpleFormat)
      success: (response) ->
        Error.show_success_flash_msg(I18n.t(translations(), 'activerecord.success.strategic_status.order'))
        button.prop('disabled', false).text(originalText)
      error: (xhr, status, error) ->
        response = xhr.responseJSON
        Error.show_alert_flash_msg(I18n.t(translations(), 'activerecord.errors.strategic_status.order'))
        button.prop('disabled', false).text(originalText)

  # Função para construir dados ordenados a partir do sortableListsToArray
  buildOrderedDataFromSortable = (items) ->
    orderedData = []
    
    if items && items.length > 0
      for item in items
        parent_id = if item.parentId == undefined then null else parseInt(item.parentId)
        
        orderedData.push
          id: parseInt(item.id)
          parentId: parent_id
          order: item.order

    orderedData

  # Função para mostrar mensagem de sucesso
  showSuccessMessage = (message) ->
    if typeof toastr isnt 'undefined'
      toastr.success(message)
    else
      alert(message)

  # Função para mostrar mensagem de erro
  showErrorMessage = (message) ->
    if typeof toastr isnt 'undefined'
      toastr.error(message)
    else
      alert(message) 